import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import customConfirmationDecisionMagazine from "../../../../src/content/decision-magazine-2024 /customConfirmationDigitalcopy";
import "../../../../src/content/decision-magazine-2024 /decision-magazine.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  customConfirmationDecisionMagazine,
  React
};